<template>
  <details class="w-100 mb-3" open>
    <summary class="text-start">
      <h2 class="d-inline fs-4">{{ title }}</h2>
    </summary>

    <div class="mt-3">
      <ckeditor
        :model-value="modelValue"
        :editor="editor"
        :config="editorConfig"
        @update:model-value="$emit('update:modelValue', $event)"
      />
    </div>
    <slot />
  </details>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';
import { ClassicEditor, EditorConfig } from 'ckeditor5';
import { Ckeditor } from '@ckeditor/ckeditor5-vue';

export default defineComponent({
  components: {
    Ckeditor,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    editor: {
      type: Object as PropType<ClassicEditor>,
      required: true,
    },
    editorConfig: {
      type: Object as PropType<EditorConfig>,
      required: true,
    },
    modelValue: {
      type: String,
      required: true,
    },
  },
  emits: ['update:modelValue'],
});
</script>
